import { Constants } from './constants';

export const Utils = {
  checkIfMobile: (): boolean => {
    let check: boolean = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window["opera"]);
    return check;
  },
  isIOS: (): boolean => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  },
  fileExists: (path: string): boolean => {
    var http = new XMLHttpRequest();

    http.open('HEAD', path, false);
    http.send();

    return http.status != 404;
  },
  findById: (value: number|string, items: any[], field: string = 'id'): any => {
    if(value == null) {
      return null;
    }
    
    for(let obj of items) {
      if(obj[field].toString() == value.toString()) {
        return obj;
      }
    }
    return null;
  },
  timeSince: (from: Date|string, to: Date|string): string => {
    if(typeof from === "string") {
      from = new Date(from);
    }
    if(typeof to === "string") {
      to = new Date(to);
    }

    let diff = to.getTime() - from.getTime();
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;

    let minutes = Math.floor(diff / minute) % 60;
    let hours = Math.floor(diff / hour) % 24;
    let days = Math.floor(diff / day);

    let str = "";
    if (days > 0)
      str += `${days}d, `;
    if (hours > 0)
      str += `${hours}h e `;

    return str + `${minutes}min`;
  },
  dateToString(date: Date | string, is_rails_timestamp: boolean = false, show_time: boolean = true): string {
    if(date == null)
        return null;

    if(typeof date == 'string') {
        date = new Date(date);
    }
    if(is_rails_timestamp) {
        date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
    }
    let formatted_date = date.toISOString().substr(0, 10).split('-').reverse().join('/');
    let time = date.toISOString().substr(11, 8);

    if(show_time) {
        return formatted_date + ' ' + time;
    } else {
        return formatted_date;
    }
  },
  dateToISO(date: Date | string, zeroedTimezone: boolean = false): string {
    if(date == null)
        return null;
    
    if(typeof date == 'string') {
        date = new Date(date);
    }
    if(zeroedTimezone) {
      date = new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000)); 
    }

    let month: any = date.getMonth() + 1;
    if(month < 10) {
      month = "0" + month;
    }
    let day: any = date.getDate();
    if(day < 10) {
      day = "0" + day;
    }
    let hours: any = date.getHours();
    if(hours < 10) {
      hours = "0" + hours;
    }
    let minutes: any = date.getMinutes();
    if(minutes < 10) {
      minutes = "0" + minutes;
    }
    let seconds: any = date.getSeconds();
    if(seconds < 10) {
      seconds = "0" + seconds;
    }
    return `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },
  datePtBrToISO(date: string): string {
    if(date == null) {
      return null;
    }
    
    let sections: string[] = date.split(/-|\/|\./);
    let year = sections[2].split(' ')[0];
    let time = sections[2].split(' ')[1];
    return `${year}-${sections[1]}-${sections[0]} ${time}`;
  },
  clone: (obj: Object): any => {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = Utils.clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = Utils.clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  },
  equals( x, y ) {
    if ( x === y ) return true;
      // if both x and y are null or undefined and exactly the same

    if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) return false;
      // if they are not strictly equal, they both need to be Objects

    if ( x.constructor !== y.constructor ) return false;
      // they must have the exact same prototype chain, the closest we can do is
      // test there constructor.

    for ( var p in x ) {
      if ( ! x.hasOwnProperty( p ) ) continue;
        // other properties were tested using x.constructor === y.constructor

      if ( ! y.hasOwnProperty( p ) ) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined

      if ( x[ p ] === y[ p ] ) continue;
        // if they have the same strict value or identity then they are equal

      if ( typeof( x[ p ] ) !== "object" ) return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal

      if ( ! Utils.equals( x[ p ],  y[ p ] ) ) return false;
        // Objects and Arrays must be tested recursively
    }

    for ( p in y ) {
      if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) ) return false;
        // allows x[ p ] to be set to undefined
    }
    return true;
  },
  isOnSchedule(parsedSchedule: {[dayOfWeek: string]: string[]}, openingMins: number = 30, closingMins: number = 30): {
    status: 'closed'|'closing'|'opening'|'open',
    currentShift: {
      opensAt: string,
      closesAt: string
    }
  } {
    const daysOfWeek = Constants.daysOfWeek;
    const now = new Date();

    const today = daysOfWeek[now.getDay()];

    let res: 'closed'|'closing'|'opening'|'open';
    let currentShift: {
      opensAt: string,
      closesAt: string
    } = {
      opensAt: null,
      closesAt: null
    };

    if(!parsedSchedule[today])
      return {status: 'closed', currentShift: currentShift};

    let time: number = now.getHours() + now.getMinutes()/60;
    const shifts: string[] = parsedSchedule[today];
    for(let shift of shifts) {
      let openStr: string = shift.split('-')[0];
      let closedStr: string = shift.split('-')[1];

      let open_h = openStr.split(':')[0];
      let open_m = openStr.indexOf(':') > -1 ? openStr.split(':')[1] : 0;

      let closed_h = closedStr.split(':')[0];
      let closed_m = closedStr.indexOf(':') > -1 ? closedStr.split(':')[1] : 0;

      let openAt = Number(open_h) + Number(open_m)/60;
      let closedAt = Number(closed_h) + Number(closed_m)/60;

      if(closedAt < openAt) { // for example, opens 19 pm and closes 03 am and now it's 2 am
        if(time < closedAt) {
          time += 24; // now it's 26 pm, so we have 27 - 26 = 1 hour left!
        }
        closedAt += 24; // closed at 27 pm (it's crazy, but follow me)
      }

      if(time < openAt) {
        res = 'closed';
        if(time + openingMins/60 >= openAt) {
          res = 'opening';
        }
      } else {
        if(time > closedAt) {
          res = 'closed';
        } else {
          if(time + closingMins/60 >= closedAt) {
            res = 'closing';
            currentShift = {opensAt: openStr, closesAt: closedStr};
          } else {
            res = 'open';
          }
        }
      }
      
      if(res != 'closed')
        return {status: res, currentShift: currentShift};
    }

    return {status: res, currentShift: currentShift};
  },
  pushIfNotExists(arr: Array<any>, toPush: any): boolean {
    let found: boolean = false;
    for(let el of arr) {
      if(Utils.equals(el, toPush)) {
        found = true;
        break;
      }
    }

    if(found) {
      return false;
    } else {
      arr.push(toPush);
      return true;
    }
  },
  arrayDiff(a1: Array<any>, a2: Array<any>): Array<any> {
    var a = [], diff = [];

    for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }

    for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }

    for (var k in a) {
      diff.push(k);
    }

    return diff;
  }
}